<div class="mb-4">
  <h5 class="text-[20px] text-heading font-bold mb-1 leading-none">Liquidation</h5>
  <ul>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.dashboard">Home</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.disbursementNavigator">Disbursement</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.liquidation">Liquidation</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] font-semibold font-normal inline-block mr-2">
      {{rawLiqId}}
    </li>
  </ul>
</div>

<div class="bg-white p-4 mb-10">
  <div *ngIf="waitHandler.processing" class="alert alert-info">We are handling your request...</div>
  <ng-container *ngIf="currentLiq$|async as liq">
    <div class="grid grid-cols-12 gap-x-4">
      <div class="col-span-12 md:col-span-4 flex-centered">
        <div class="text-lg font-bold mb-4">Review Liquidation</div>
      </div>
      <div class="col-span-12 md:col-span-4">
        <div class="flex-end"></div>
      </div>
      <div class="col-span-12 md:col-span-4">
        <div class="form-submit">

          <ng-container *ngIf="!liq.Voucher && liq.update_status">
            <button [disabled]="waitHandler.processing" (click)="approveRequest()" type="button"
              class="custom-button custom-button-primary">
              <i class="fa-light fa-check"></i> Approve Request
            </button>

            <!-- <button [disabled]="waitHandler.processing" (click)="disapproveRequest()" type="button"
              class="custom-button">
              <i class="fa-light fa-xmark"></i> Disapprove Request
            </button> -->
          </ng-container>

        </div>
      </div>
    </div>

    <div *ngIf="Helper.date.compareDate(Helper.date.newDate, '>', Helper.date.addDay(liq.created_at, 6)) && liq.Status != 'Closed'" class="alert alert-danger">
      <i class="fa-solid fa-circle-exclamation"></i>
      Request is over the grace period for liquidation. This request if for NTE.
    </div>

    <div *ngIf="liq.CA_Request.Amount != (liq.Items|arrMap:'ApprovedAmount'|sum)" class="alert alert-danger">
      <i class="fa-solid fa-circle-exclamation"></i>
      Amount of {{(liq.CA_Request.Amount - (liq.Items|arrMap:'ApprovedAmount'|sum))|currency:'₱ '}} is not liquidated.
    </div>

    <div class="table-responsive mb-4">
      <table class="custom-table custom-table-default custom-table-border-row">
        <thead>
          <tr>
            <th colspan="3">
              <span class="text-base">
                Information
              </span>
            </th>
            <th>
              <div class="flex-end">
                <span class="badge badge-default whitespace-nowrap">
                  {{liq.Status||'No Status'}}
                </span>

                <ng-container [ngSwitch]="liq.RequestStatus">
                  <span *ngSwitchCase="'Approved'" class="badge badge-green whitespace-nowrap">
                    {{liq.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchCase="'Disapproved'" class="badge badge-red whitespace-nowrap">
                    {{liq.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchCase="'Pending'" class="badge badge-yellow whitespace-nowrap">
                    {{liq.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchDefault class="badge badge-default whitespace-nowrap">
                    {{liq.RequestStatus||'No Status'}}
                  </span>
                </ng-container>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2">Total Approved Amount</td>
            <td colspan="2">
              <div class="text-end font-bold text-lg text-red-400">{{liq.OverallApprovedAmount|currency:'₱ '}}</div>
            </td>
          </tr>
          <tr>
            <td colspan="2">Total Amount</td>
            <td colspan="2">
              <div class="text-end text-base">{{liq.OverallTotalAmount|currency:'₱ '}}</div>
            </td>
          </tr>
          <tr>
            <td colspan="2">Liquidation ID</td>
            <td colspan="2" class="text-end">{{rawLiqId}}</td>
          </tr>
          <tr>
            <td colspan="2">CA Reference Number</td>
            <td colspan="2" class="text-end">
              <a [routerLink]="[routes.cashAdvance, liq.CA_Request.CntrlNumber]" class="whitespace-nowrap">
                <i class="fa-light fa-receipt text-md"></i>
                -
                <span class="underline">
                  {{liq.CA_Request.CntrlNumber||''}}
                </span>
              </a>
            </td>
          </tr>
          <tr>
            <td colspan="2">CA Total Amount</td>
            <td colspan="2" class="text-end font-bold text-red-400">{{liq.CA_Request.Amount|currency:'₱ '}}</td>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th colspan="4">
              <span class="text-base">
                Liquidation Status History
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!liq.History.length">
            <td colspan="2">You will find status history here!</td>
          </tr>
          <tr *ngFor="let item of liq.History; let i = index">
            <td><span class="text-muted whitespace-nowrap">{{item.PrevStatus||'New Request'}}</span></td>
            <td><i class="fa-thin fa-angles-right"></i></td>
            <td>
              <span [className]="i == 0 ? 'font-bold whitespace-nowrap' : 'text-muted whitespace-nowrap'">
                {{item.Status}}
              </span>
            </td>
            <td>
              <div class="text-end whitespace-nowrap">
                <span *ngIf="item.CreatedBy as by">
                  ({{Helper.users.formatUID(by.ID)}}) {{by.LastName}}, {{by.FirstName}} |
                </span>
                {{item.created_at|formatDateTime}}
              </div>
              <div class="text-end whitespace-nowrap">
                {{item.Remarks||'No Remarks'}}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="liq.update_status && !(readInfo01$|async)" class="alert alert-info mb-4">
      <div class="flex justify-between">
        <span>You can only approve/disapprove item one at a time.</span>
        <a (click)="readInfo01$.next(true)" class="font-bold text-lg" href="javascript:void(0);"><i
            class="fa fa-xmark"></i></a>
      </div>
    </div>

    <div class="table-responsive mb-4 mb-4">
      <table class="custom-table custom-table-default custom-table-border-all">
        <thead>
          <tr>
            <th colspan="6" class=""><span class="text-base">Reimbursement Items</span></th>
            <th colspan="4" class="text-center "><span class="text-base">Item Approval</span></th>
          </tr>
        </thead>
        <thead>
          <tr>
            <th>Description</th>
            <th>Vatable Sale</th>
            <th>Vat Amount</th>
            <th>Total Amount</th>
            <th>Proof</th>
            <th>Approval History</th>

            <ng-container>
              <th class="text-center">Action</th>
              <th>Approved Amount</th>
              <th>Remarks</th>
            </ng-container>

            <ng-container *ngIf="liq.AddChartOfAccountItem===1">
              <th>Account</th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!liq.Items.length">
            <td class="text-muted" colspan="10">You will find item to liquidate here!</td>
          </tr>
          <tr *ngFor="let item of liq.Items; let i = index">
            <td class="whitespace-nowrap">{{item.Description||'No description'}}</td>
            <td class="text-right">{{item.VatableSales|currency:'₱ '}}</td>
            <td class="text-right">{{item.VAT|currency:'₱ '}}</td>
            <td class="text-right">{{[item.VatableSales, item.VAT]|sum|currency:'₱ '}}</td>
            <td class="">
              <a *ngIf="item.ProofURL" [href]="item.ProofURL" target="_blank" class="link whitespace-nowrap">
                <i class="fa-light fa-receipt text-md"></i>
                -
                <span class="text-red-400">View Proof</span>
              </a>
            </td>
            <td>
              <a (click)="viewItemHistory(i, item.History)" href="javascript:void(0);" class="link whitespace-nowrap">
                <i class="fa-light fa-clock-rotate-left"></i>
                -
                <span class="text-red-400">View History</span>
              </a>
            </td>

            <ng-container *ngIf="getFormGroup(i) as fg" [formGroup]="fg">
              <td>
                <div [ngSwitch]="item.Status" class="flex-centered mb-4">
                  <span *ngSwitchCase="'Approved'" class="badge badge-green whitespace-nowrap">Approved</span>
                  <span *ngSwitchCase="'Disapproved'" class="badge badge-red whitespace-nowrap">Disapproved</span>
                  <ng-container *ngSwitchDefault>
                    <span *ngIf="liq.NextStatus != null" class="badge badge-yellow whitespace-nowrap">Pending
                      Approval</span>
                  </ng-container>
                </div>

                <ng-container *ngIf="!item.Status && !liq.Voucher && liq.update_status">
                  <div class="grid grid-cols-2 gap-x-4">
                    <div class="col-span-1 flex-centered">
                      <button [disabled]="waitHandler.processing" (click)="approveItem(i)"
                        class="custom-button-sm custom-button-primary text-center" matTooltip="Approve">
                        <i class="fa-light fa-check"></i>
                      </button>
                    </div>
                    <div class="col-span-1 flex-centered">
                      <button [disabled]="waitHandler.processing" (click)="disapproveItem(i)"
                        class="custom-button-sm text-center" matTooltip="Disapprove">
                        <i class="fa-light fa-xmark"></i>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </td>
              <td class="{{fg.controls.ApprovedAmount.disabled ? 'bg-zinc-100' :''}}">
                <div class="flex justify-between gap-x-4">
                  <span>₱</span>
                  <input [formControl]="fg.controls.ApprovedAmount" type="number"
                    class="w-[100%] h-[100%] bg-transparent border-none outline-none text-left" placeholder="Enter Amount"
                    (keypress)="Helper.input.positiveNumeric($event)">
                </div>
              </td>
              <td class="{{fg.controls.Remarks.disabled ? 'bg-zinc-100' :''}}">
                <input [formControl]="fg.controls.Remarks" type="text"
                  class="w-[100%] h-[100%] bg-transparent border-none outline-none" [placeholder]="fg.controls.Remarks.disabled ? '' : 'Enter Remarks'">
              </td>
              <td *ngIf="liq.AddChartOfAccountItem===1" class="{{fg.controls.Account.disabled ? 'bg-zinc-100' :''}}">
                <ng-container [ngSwitch]="fg.controls.Account.disabled">
                  <a *ngSwitchCase="false" (click)="setAccountItem(i)" class="link whitespace-nowrap" href="javascript:void(0);">
                    <i class="fal fa-pen"></i>
                    -
                    <span class="text-red-400">{{fg.controls.Account.value||'Enter Account'}}</span>
                  </a>
                  <span *ngSwitchDefault class="whitespace-nowrap">{{fg.controls.Account.value}}</span>
                </ng-container>
                <!-- <app-acc-auto-complete-input [formControlAttr]="fg.controls.Account" [formGroupAttr]="fg"
                  [options]="chartAccList$|async"
                  className="w-[100%] h-[100%] bg-transparent border-none outline-none"
                  placeHolder="Account"></app-acc-auto-complete-input> -->
              </td>
            </ng-container>

          </tr>
          <tr *ngIf="loginS.userData?.ID === liq.CA_Request.RequestedBy.ID && liq.Status != 'Closed'">
            <td colspan="10">
              <a (click)="addLiquidationItem()" class="link" href="javascript:void(0);">
                <i class="fal fa-plus-circle"></i>
                -
                <span class="text-red-400">Add item to liquidate.</span>
              </a>
            </td>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th></th>
            <th class="text-end">{{liq.Items|arrMap:'VatableSales'|sum|currency:'₱ '}}</th>
            <th class="text-end">{{liq.Items|arrMap:'VAT'|sum|currency:'₱ '}}</th>
            <th class="text-end">{{[liq.Items|arrMap:'VatableSales'|sum, liq.Items|arrMap:'VAT'|sum]|sum|currency:'₱ '}}</th>
            <th colspan="3"></th>
            <th>{{liq.Items|arrMap:'ApprovedAmount'|sum|currency:'₱ '}}</th>
            <th colspan="2"></th>
          </tr>
        </thead>
      </table>
    </div>
  </ng-container>
</div>